import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt,
} from "../../components/CustomComponent.js";

// ตำแหน่ง (Position Master) - ไม่ผูกกับข้อมูลอื่น เป็นข้อมูลระบุตำแหน่งของพนักงานเท่านั้น ไม่ถูกใช้กับเงื่อนไขสิทธิ์ใด ๆ
// โครงสร้างตามหน้า sections เชื่อมต่อ API: admin/positions
export default class AdminPositions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      modal_create: false,
      modal_update: false,
      count: 0,
      page: 1,

      // Form States (Modal)
      uid: "",
      position_code: "",
      name: "",
      is_active: "Active",

      data: [],
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data = [], count = 0;
    loading(true);

    const result = await GET("admin/positions", {
      page_size: 10,
      page: page,
      data_search: filter_search,
    });

    if (result?.status) {
      data = result.data || [];
      count = result.pagination?.count || 0;
    }
    this.setState({ data, count, page });
    loading(false);
  };

  CreateUpdate = async () => {
    const { uid, position_code, name, is_active } = this.state;

    if (!position_code.trim()) {
      alert("", "warning", t("warning"), t("verify_position_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_position_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      const body = {
        position_code: position_code.trim(),
        name: name.trim(),
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/positions", body)
        : await PUT("admin/positions/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      const result = await DELETE("admin/positions/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  render() {
    const {
      data,
      count,
      page,
      filter_search,
      modal_create,
      modal_update,

      position_code,
      name,
      is_active,
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("position_management")}</h3>
              <div className="text-secondary text-14">{t("manage_positions_desc")}</div>
            </div>
          </div>

          {/* Top Filter Toolbar */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex gap-2 flex-wrap">
                <div className="position-relative flex-grow-1" style={{ maxWidth: "350px" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                    {""}
                  </span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-350"
                    placeholder={t("search_positions")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                  />
                </div>
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                  onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
                >
                  {t("clear_all")}
                </button>
              </div>
              {can("positions.create") && (
                <button
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                  onClick={() =>
                    this.setState({
                      modal_create: true,
                      uid: "",
                      // เปิดจากตัวกรองหน่วยงานอยู่ -> ตั้งหน่วยงานนั้นไว้ให้เลย
                                    position_code: "",
                      name: "",
                      is_active: "Active",
                    })
                  }
                >
                  <span className="me-2 text-16">+</span> {t("add_position")}
                </button>
              )}
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "700px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 border-0 wpx-200">{t("position_code")}</th>
                    <th className="py-3 border-0 wpx-250">{t("position_name")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, idx) => (
                      <tr key={idx} className="border-bottom border-light bg-white">
                        <td>
                          <div className="text-secondary text-14">{item.position_code || "-"}</div>
                        </td>
                        <td>
                          <div className="text-secondary text-14">{item.name}</div>
                        </td>

                        {/* Status */}
                        <td className="text-center">
                          {item.is_active ? (
                            <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">
                              {t("active")}
                            </span>
                          ) : (
                            <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">
                              {t("inactive")}
                            </span>
                          )}
                        </td>

                        {/* Actions */}
                        <td className="text-center">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            {can("positions.update") && (
                              <ActionIconButton
                                label={t("edit")}
                                icon={ACTION_ICONS.edit}
                                variant="warning"
                                onClick={() =>
                                  this.setState({
                                    modal_update: true,
                                    uid: item.uid,
                                    position_code: item.position_code || "",
                                    name: item.name || "",
                                    is_active: item.is_active ? "Active" : "Inactive",
                                  })
                                }
                              />
                            )}
                            {can("positions.delete") && (
                              <ActionIconButton
                                label={t("delete")}
                                icon={ACTION_ICONS.delete}
                                variant="danger"
                                onClick={() => this.Delete(item.uid)}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4 text-secondary">
                        {t("no_data_found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
            <div>
              {t("showing")} {count ? fmtInt((page - 1) * 10 + 1) : 0}-{fmtInt((page - 1) * 10 + data.length)} {t("of")} {fmtInt(count)} {t("items")}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / 10) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        {/* MODAL: CREATE / UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() => this.setState({ modal_create: false, modal_update: false })}
          centered
          contentClassName="border-0 rounded-4  shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">
              {modal_update ? t("edit_position") : t("add_new_position")}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="row g-4">
              {/* Basic Information */}
              <div className="col-12">
                <small className="text-muted d-block mb-3">{t("position_info_desc")}</small>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("position_code")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      maxLength={100}
                      placeholder={t("position_code_placeholder")}
                      value={position_code}
                      onChange={(e) => this.setState({ position_code: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("position_name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      maxLength={200}
                      placeholder={t("position_name_placeholder")}
                      value={name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              {/* Status */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon text-primary me-2">{""}</span> {t("status")}
                </h6>
                <small className="text-muted d-block mb-3">{t("status_desc")}</small>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="positionStatus"
                      id="positionStatusActive"
                      checked={is_active === "Active"}
                      onChange={() => this.setState({ is_active: "Active" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="positionStatusActive">
                      {t("active")}
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="positionStatus"
                      id="positionStatusInactive"
                      checked={is_active === "Inactive"}
                      onChange={() => this.setState({ is_active: "Inactive" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="positionStatusInactive">
                      {t("inactive")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false })}
            >
              {t("cancel")}
            </button>
            <button
              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
              style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
              onClick={this.CreateUpdate}
            >
              <span className="icon me-2">{""}</span> {t("save")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
